import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Button = styled.button`
  border: none;
  cursor: pointer;
  background: #fff;
`;

export const ListWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  max-width: 300px;
  scroll-behavior: smooth;
`;

export const ListItem = styled.div`
  min-width: 100px;
  background-color: none;
  border-radius: 5px;
  text-align: center;
  color: #000;
`;